/*
 * @Author: wangchong
 * @Desc:
 */
import { observable, action, runInAction } from "mobx";
import { getLabel } from '@weapp/utils';
import { Dialog } from '@weapp/ui';

import * as API from '../../../../../api/pc/tenantInfo';
import { teamsStore } from '../../../../../store/pc/index'
import { InviteCodeCheckType, createTenantCheckType } from './type';
const { message } = Dialog;

export class TeamsCreateStore {

  @observable InviteCodeMsg: any = null;//邀请码校验

  @observable createLoading = false;

  @action
  checkInviteCode = (params: InviteCodeCheckType) => {
    API.checkInviteCode(params).then((result) => {
      runInAction(() => {
        if (result?.data?.errorMsg) {
          this.InviteCodeMsg = {
            type: 'error',
            content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
          }
        } else {
          this.InviteCodeMsg = {
            type: 'success'
          };
        }
      });
    });

  }
  @action
  createTenant = (params: createTenantCheckType) => {
    if (this.createLoading) {
      return;
    }
    this.createLoading = true;
    //创建工作空间
    teamsStore.updateCurrentView('build');
    API.createTenant(params).then((result: any) => {
      runInAction(() => {
        this.createLoading = false;
        if (result?.data?.errorMsg) {
          const msg = result.data.errorMsg
          message({
            type: "error",
            content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
          });
          teamsStore.updateCurrentView('create');
        } else {
          if (result?.data?.redirectUrl) {
            window.location.href = result.data.redirectUrl;
          }
        }
      });
    }).catch(() => {
      runInAction(() => {
        this.createLoading = false
      })
    });

  }
}
const instance = new TeamsCreateStore();

export default instance;
export type TeamsCreateStoreType = Pick<TeamsCreateStore, keyof TeamsCreateStore>;
